import Button from '@/components/atoms/Button';
import { Filter } from 'iconsax-react';
import { useTranslation } from 'react-i18next';

export default function FilterBtn({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();

  return (
    <Button variant="outline" onClick={onClick}>
      <span className="flex items-center gap-x-2">
        <Filter size={15} />

        {t('home.filters')}
      </span>
    </Button>
  );
}
